import "regenerator-runtime/runtime";
import axios from "axios";
let mainvar = spedizioniweb2;
import useBSSLogger from '../hooks/useBSSLogger';
import https from 'https'
import jqParam from 'jquery-param'
import saveAs from 'file-saver';
import { ext2mime } from "./datautils";
import __t from "./traduzioni"; 


const {logger} = useBSSLogger(); 

const CancelToken = axios.CancelToken;
const ctsource = CancelToken.source();

let apiclient = null;
let wpclient = null;

const CODICIERRORIAJAX = {
    UTENTEDIVERSO: __t("utentediverso"),
    UTENTENONLOGGATO: __t("utentenonloggato"),
}

const defaultAjaxError = {response: {data: [{type: "error", message: "Nessun errore specificato. Probabile CORS error!"}]} }

/**
 * Ritorna un'istanza di axios che ad ogni richiesta in automatico: 
 * 
 *  -utilizza l'url ricevuto come formparam 'action'
 * 
 *  -come url l'url di base (admin-ajax.php)
 * 
 *  -aggiunge ai formparam il nonce
 * 
 * @returns {import("axios").AxiosInstance}
 */
const buildwpclient = () => {
    wpclient = axios.create({
        withCredentials: false,
        baseURL: mainvar.ajaxurl, 
        timeout: 20000,
        headers: { "Content-Type": "application/x-www-form-urlencoded"},        
        httpsAgent: new https.Agent({rejectUnauthorized: spedizioniweb2.rejectUnauthorized ?? false})        
    });

    wpclient.interceptors.request.use(async (cfg) => {

        logger.debug("configurazione richiesta axios wpclient", cfg)

        if(mainvar.nou(cfg.data)){
            cfg.data = {};
        }

        cfg.data.nonce = mainvar.nonce;
        cfg.data.action = cfg.url;
        cfg.url = cfg.baseURL
        // cfg.data = new URLSearchParams(cfg.data).toString();
        cfg.data = jqParam(cfg.data);


        return cfg;
    });

    return wpclient;
}

/**
 * Ritorna un'istanza di axios che ad ogni richiesta in automatico: 
 * 
 *  -utilizza come baseurl quello definito in env.php, base url viene ignorato se viene passato un url assoluto
 * 
 *  -aggiunge il token di keycloak negli header (solo se presente)
 * 
 *  - aggiunge gli header con il session id dell'utente, azienda, esercizio e Content-Type form-urlencoded
 * 
 *  - se il content type non viene modificato il body passato come oggetto json viene automaticamente convertito in form url encoded come con $.param
 * 
 *  - se viene passato come cfg downloadCfg vengono aggiunti gli headers necesari ad ottenere come response un buffer. 
 * downloadCfg.type se non presente è calcolato automaticamente in base a downloadCfg.name. 
 * Se quest'ultimo è null il download non parte in automatico e il type viene considerato pdf.
 * 
 * Esempio download
 * 
 * const data = await getapiclient().post("testataordine/stampa", {
 *           iddoc,
 *           idtipodoc
 *       }, {
 *           downloadCfg: {
 *               name: `${iddoc}.pdf`
 *           }
 *       })
 * 
 * @returns {import("axios").AxiosInstance}
 */
const buildapiclient = () => {


    apiclient = axios.create({
        cancelToken: ctsource.token,
        withCredentials: false,
        baseURL: localStorage?.getItem("wsbase") ?? mainvar.ws.baseurl, 
        timeout: 120000,
        headers: { 
            "Content-Type": "application/x-www-form-urlencoded",
            "BSS-AZIENDA": "*",
            "BSS-ESERCIZIO": "*",
            "BSS-CLIENTSESSIONID": spedizioniweb2.clientsessionid,            
        }, 
        httpsAgent: new https.Agent({rejectUnauthorized: spedizioniweb2.rejectUnauthorized ?? false}),
    });
    
    apiclient.interceptors.request.use(async (cfg) => {
        let token = mainvar.recursiveGetter(mainvar, "keycloak.token", null);        

        logger.debug("url richiesta ajax", cfg.url);
        
        if(![null, undefined].includes(cfg.downloadCfg)){
            cfg.headers.type = 'application/octet-stream';
            cfg.responseType = 'arraybuffer';
        }
        
        if(cfg.headers["Content-Type"] === "application/x-www-form-urlencoded") {
            
            // cfg.data = new URLSearchParams(cfg.data).toString();
            cfg.data = jqParam(cfg.data);
            logger.finer("dati formurlencoded", cfg.data)
        }

        
        const utenteWP = mainvar?.user?.data?.user_login ?? null;
        const utenteKC = mainvar?.keycloak?.tokenParsed?.preferred_username ?? null;
            
        if(utenteWP && utenteKC && utenteWP.toUpperCase() !== utenteKC.toUpperCase()){
            logger.debug("gli utenti di wordpress e keycloak non coincidono", "utente wp", utenteWP, "utente kc", utenteKC, mainvar)
            const {data} = await getwpclient().post("spedizioniweb2_logout");
            localStorage.setItem("spedizioniweb2_flashMessages", JSON.stringify({"*": __t("uscitatokennonvalido")}));
            localStorage.removeItem("spedizioniweb2_preventivo_carrello");
            localStorage.removeItem("spedizioniweb2_preventivo_form");
            localStorage.removeItem("spedizioniweb2_clipboard");
            
            ctsource.cancel("UTENTEDIVERSO")
        }
        
        if (token !== null) {                         
    
            try {
                
                const refreshed = await mainvar.aggiornatoken();
                token = mainvar.recursiveGetter(mainvar, "keycloak.token", null);
                logger.debug("token aggiornato?", refreshed) 
            } catch(err){
                logger.finer("non è stato possibile aggiornare il token!", err);
            }
            
            logger.debug("aggiungo il token all'header!");            
            cfg.headers["Authorization"] = "Bearer " + token;
            
            const referral = localStorage?.getItem("spedizioniweb2_referral") ?? null;
            if(cfg.url.includes("carrello/userscart") && referral !== null){
                cfg.headers["BSS-REFERRAL"] = referral;            
                localStorage?.removeItem("spedizioniweb2_referral")
            }
                    
        } else {
            logger.debug("nessun token da aggiungere!", cfg);        
            if(cfg.tokenRequired === true){
                logger.debug("il webservice", cfg.url, "richiede un token, ma l'utente non è loggato")
                throw new Error("UTENTENONLOGGATO")
            }    
        }
    
        return cfg;
    });

    apiclient.interceptors.response.use((response) => {

        if(![null, undefined].includes(response.config.downloadCfg)){
            let {type = null, name = null} = response.config.downloadCfg;

            if(name === null){
                type = "application.pdf";
            } else {
                type = ext2mime[name.split('.').pop()] ?? "application.pdf"
            }

            response = new Blob([response.data], { type });
            if(name !== null){
                saveAs(response, name)
            }
        }
        
        return response;
    }, (error) => {
        logger.debug("client errore ajax", apiclient.defaults)
        const errResp = error?.response ?? null;
        const suppressErrors = errResp?.config?.suppressErrors ?? false;

        if(suppressErrors !== true){
            const errorevent = new CustomEvent("spedizioniweb2_error", {
                detail: {message: errResp?.data ?? error.message ?? defaultAjaxError, originalError: error}, 
                context: "api"
            })
            logger.error("errore chiamata ajax", errResp)
            document.dispatchEvent(errorevent)

        }

        
        throw error;
    })

    return apiclient;
}

/**
 * Semplifica le chiamate ajax agli endpoint esposti da wildfly. 
 * Utilizzo di base:
 *  getapiclient().post(url, jsonbody, cfgOverride)
 * Al posto di 'post' si può usare 'get'. 
 * Solo url è obbligatorio
 * cfgOverride permette di fare l'override della configurazione di base
 * 
 * @returns {import("axios").AxiosInstance}
 */
const getapiclient = () => {
    if([null, undefined].includes(apiclient)){
        
        apiclient = buildapiclient();

    }

    return apiclient;
}

const getwpclient = () => {
    if([null, undefined].includes(wpclient)){
        
        wpclient = buildwpclient();

    }

    return wpclient;
}

export default getapiclient;
export {getwpclient, CODICIERRORIAJAX}
